import Layouts from 'shared/components/layouts'
import React, { useCallback } from 'react'
import styles from './header.module.css'
import { HeaderProps } from './types'
import { Title } from 'ppp/title'

export const Header = ({ projectTitle, profilePicture, gallery, videoEmbedUrl }: HeaderProps) => {
  const onVideoLinkClicked: React.MouseEventHandler<HTMLAnchorElement> = useCallback((event) => {
    event.preventDefault()
    const videoPlayer = document.querySelector('#video-player')
    if (videoPlayer instanceof HTMLElement) {
      videoPlayer.scrollIntoView({ behavior: 'smooth' })
      setTimeout(() => videoPlayer.focus(), 500)
    }
  }, [])

  return (
    <header>
      <Layouts.Stack space="var(--space-sm)">
        <div className={styles.galleryContainer}>
          {profilePicture ? (
            gallery
          ) : (
            <div className={styles.galleryPlaceholderContainer}>
              <span className={styles.galleryPlaceholderContent}>{i18n.t('projects.show.gallery.placeholder')}</span>
            </div>
          )}
        </div>

        {videoEmbedUrl && (
          <a href="#video-player" className={styles.videoLink} onClick={onVideoLinkClicked}>
            {i18n.t('projects.show.watch_video_link')}
          </a>
        )}

        <div className={`${styles.title} container`}>
          <Title projectTitle={projectTitle} />
        </div>
      </Layouts.Stack>
    </header>
  )
}
